import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00af0013"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = {
  class: "navbar navbar-expand-xl navbar-dark fixed-top",
  style: {"background-color":"#072878"}
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" El BICHO DE LOS DIBUJOS ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#navbarOffcanvas",
  "aria-controls": "navbarOffcanvas",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_6 = {
  class: "offcanvas offcanvas-end",
  id: "navbarOffcanvas",
  tabindex: "-1",
  "aria-labelledby": "offcanvasNavbarLabel",
  style: {"background-color":"#072878"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "offcanvas-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "offcanvas-title text-light",
    id: "offcanvasNavbarLabel"
  }, " Menú "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close btn-close-white text-reset",
    "data-bs-dismiss": "offcanvas",
    "aria-label": "Close"
  })
], -1))
const _hoisted_8 = { class: "offcanvas-body" }
const _hoisted_9 = { class: "navbar-nav justify-content-end flex-grow-1 pe-3" }
const _hoisted_10 = { class: "container-fluid" }

import { ref, computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const menu = ref([
  {
    path: '/',
    name: 'Inicio',
    icon: 'fa-solid fa-house',
    size: 'lg',
  },
  {
    path: '/drawings',
    name: 'Dibujos',
    icon: 'fa-solid fa-pen',
    size: 'lg',
  },
  {
    path: '/thoughts',
    name: 'Pensamientos',
    icon: 'fa-solid fa-quote-left',
    size: 'lg',
  },
  {
    path: '/stories',
    name: 'Historias',
    icon: 'fa-solid fa-book-open',
    size: 'lg',
  },
  {
    path: '/about',
    name: 'Sobre mí',
    icon: 'fa-solid fa-circle-info',
    size: 'lg',
  },
])

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "navbar-brand"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.value, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "nav-item",
                    "data-bs-dismiss": "offcanvas"
                  }, [
                    _createVNode(_component_router_link, {
                      class: "nav-link",
                      "active-class": "active",
                      to: item.path
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          class: "menu-icon",
                          icon: item.icon,
                          size: item.size
                        }, null, 8, ["icon", "size"]),
                        _createTextVNode(" " + _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})